import { render, staticRenderFns } from "./PcPhoneIcon.vue?vue&type=template&id=1351cf86&scoped=true"
import script from "./PcPhoneIcon.vue?vue&type=script&lang=js"
export * from "./PcPhoneIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1351cf86",
  null
  
)

export default component.exports